import React from "react";

import { OrderEditContextProvider } from "./context/order-edit-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class OrdersEditPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <OrderEditContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </OrderEditContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OrdersEditPage;
